import React, { useState, useEffect } from "react";
import { List, Typography, Alert, Divider } from 'antd';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ConsumableReceipt = function ConsumableReceipt(_ref) {
  var selectedItems = _ref.selectedItems,
    totalCash = _ref.totalCash;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      dataSource: selectedItems,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsxs(List.Item, {
          children: [/*#__PURE__*/_jsx(List.Item.Meta, {
            title: /*#__PURE__*/_jsx("b", {
              children: item.label
            }),
            description: /*#__PURE__*/_jsxs("div", {
              style: {
                color: '#E96479'
              },
              children: [" ", /*#__PURE__*/_jsxs("b", {
                children: ["Qte sortante: ", item.quantity]
              }), " ", /*#__PURE__*/_jsx("br", {}), "Qte Restante : ", item.available_quantity.toLocaleString('Fr')]
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("br", {})
          })]
        });
      }
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
};
export default ConsumableReceipt;